import React from 'react';
import styled from 'styled-components';
import { FormSection } from 'redux-form';

import { Input, Checkbox, LABEL_POSITION } from 'components/Shared/Forms';
import { SettingsSubGroup } from 'components/Shared/SettingsGroup';
import Collapse from 'components/Shared/Collapse';
import { BREAKPOINTS, SCAFFOLDING } from 'theme';

const CollapseContent = styled.div`
    padding: ${SCAFFOLDING.GUTTER_FACTOR(0.5)} ${SCAFFOLDING.GUTTER};
`;

const StyledCollapse = SettingsSubGroup.withComponent(Collapse);

const StyledInput = styled(Input)`
    width: 100%;

    @media (min-width: ${`${BREAKPOINTS.lg}px`}) {
        width: calc(50% - ${SCAFFOLDING.GUTTER_FACTOR(0.25)});
    }
`;

const InfoWindowArrow = ({ showArrow, defaultValues }) => (
    <FormSection name="arrow">
        <Checkbox toggleSwitch name="enabled" label="Show Arrow" labelPosition={LABEL_POSITION.LEFT} />

        <StyledCollapse collapsible isOpened={!!showArrow}>
            <CollapseContent>
                <StyledInput
                    name="length"
                    label="Arrow Length"
                    type="int"
                    unitAfter="px"
                    min={0}
                    placeholder={defaultValues.length}
                />
            </CollapseContent>
        </StyledCollapse>
    </FormSection>
);

export default InfoWindowArrow;
